import { css } from '../lib';

const aspectRatios = {
  '1x1': css`
    padding-top: 100%;
  `,
  '4x3': css`
    padding-top: calc(3 / 4 * 100%);
  `,
  '16x9': css`
    padding-top: calc(9 / 16 * 100%);
  `,
  '21x9': css`
    padding-top: calc(9 / 21 * 100%);
  `,
};

type AspectRatio = keyof typeof aspectRatios;

export const ratio = (aspect: AspectRatio) => css`
  position: relative;
  width: 100%;

  &::before {
    content: '';
    display: block;
    ${aspectRatios[aspect]}
  }

  & > * {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
